module.exports = __webpack_public_path__ + "img/read-aloud-purple.68e4a727.svg";